import styled from "styled-components";
import { palette, fonts, radii } from "../../styles/palette";

export const CopyRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
`;

export const LinkPreview = styled.code`
  font-size: 12px;
  color: ${palette.textSecondary};
  background: ${palette.surfaceMuted};
  border: 1px solid ${palette.border};
  border-radius: ${radii.sm};
  padding: 10px 12px;
  word-break: break-all;
  text-align: left;
`;

export const CopyButton = styled.button`
  font-family: ${fonts.body};
  background: ${palette.red};
  color: ${palette.white};
  border: none;
  border-radius: ${radii.sm};
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: ${palette.redHover};
  }
`;
